import {
  REGISTER_INPUT_USERNAME,
  REGISTER_INPUT_EMAIL,
  REGISTER_INPUT_PASSWORD,
  REGISTER_INPUT_REFFERAL_ID,
  REGISTER_INPUT_PHONE,
} from '../constants/register'

export const getStatus = state => state.register.status
export const getFocusedInput = state => state.register.focusedInput
export const getUsername = state => state.register[REGISTER_INPUT_USERNAME]
export const getEmail = state => state.register[REGISTER_INPUT_EMAIL]
export const getPassword = state => state.register[REGISTER_INPUT_PASSWORD]
export const getRefferalId = state => state.register[REGISTER_INPUT_REFFERAL_ID]
export const getPhone = state => state.register[REGISTER_INPUT_PHONE]
export const getUsernameError = state => state.register.errors[REGISTER_INPUT_USERNAME]
export const getEmailError = state => state.register.errors[REGISTER_INPUT_EMAIL]
export const getPasswordError = state => state.register.errors[REGISTER_INPUT_PASSWORD]
export const getKeyboardFocused = state => state.register.keyboardFocused
export const getFocusedRow = state => state.register.focusedRow
export const getFocusedCol = state => state.register.focusedCol
export const getRegisterText = state => state.register.registerText

export const getPasswordErrMessage = state => state.register.passwordErrMessage
export const getPhoneErrMessage = state => state.register.phoneErrMessage
export const getUsernameErrMessage = state => state.register.usernameErrMessage
export const getEmailErrMessage = state => state.register.emailErrMessage
export const getRefferalIdMessage = state => state.register.refferalIdMessage

export const getDisableButton = state => state.register.disableRegister
